angular.module('bbl.directives.dd-fixed', [])

// fixed position dropdown
.directive('ddFixed', [function() {
	return {
		restrict: 'EA',
		link: function($scope, $el, atts) {
			var $menu = $el.find('.dropdown-menu');

			var setDdPosition = function(dd, anchor) {
				var pos = anchor[0].getBoundingClientRect(),
					inWidth = window.innerWidth;

				dd.css({
					position: 'fixed',
					top: pos.bottom,
					right: inWidth - pos.right,
				});
			};

			var showDropdown = function() {
				$el.addClass('open');
				setDdPosition($menu, $el);

				setTimeout(function() {
					document.addEventListener('click', hideDropdown, false);
					window.addEventListener('scroll', hideDropdown, false);
				});
			};

			var hideDropdown = function() {
				$el.removeClass('open');

				document.removeEventListener('click', hideDropdown);
				window.removeEventListener('scroll', hideDropdown);
			};

			$el.bind('click', function($event) {
				if($el.hasClass('open')) {
					return hideDropdown();
				}
				return showDropdown();
			});
		}
	};
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/dd-fixed.js
 ** module id = 174
 ** module chunks = 0
 **/